jQuery(function () {
  const isEditor =
    document.body.classList.contains("block-editor-page") ||
    document.body.classList.contains("wp-admin");
  if (isEditor) return;

  const blocks = document.querySelectorAll(".js-research-institutions");
  if (!blocks.length || !window.gsap) return;

  const gsap = window.gsap;
  const ScrollTrigger =
    window.ScrollTrigger ||
    (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
    null;

  if (ScrollTrigger && gsap.registerPlugin) {
    try {
      gsap.registerPlugin(ScrollTrigger);
    } catch (e) {}
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  blocks.forEach((block) => {
    if (block.dataset.riInit === "1") return;
    block.dataset.riInit = "1";

    const items = Array.from(block.querySelectorAll(".js-ri-item"));
    if (!items.length) return;

    if (reduceMotion) {
      gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
      return;
    }

    gsap.set(items, { autoAlpha: 0, y: 14 });
    gsap.to(items, {
      autoAlpha: 1,
      y: 0,
      duration: 0.85,
      ease: "power3.out",
      stagger: 0.1,
      clearProps: "transform",
      scrollTrigger: ScrollTrigger
        ? { trigger: block, start: "top 82%", once: true }
        : undefined,
    });
  });
});
